import {SET_AUCTION, SET_ERROR, SET_INQUIRY, SET_INQUIRY_PRICE, SET_LOADING, SET_TENDERS} from "./mutation_types";


export default {
    [SET_AUCTION](state,resource){
        state.auctions = resource.data;
    },
    [SET_TENDERS](state,resource){
        state.tenders = resource.data;
    },
    [SET_INQUIRY](state,resource){
        let items=resource.data;
        const options={
            "1":"گرم",
            "2":"کیلوگرم",
            "3":"تن",
            "4":"لیتر",
            "5":"مترمکعب",
            "6":"عدد",
        };                                       
        for(const key in items.topics){
            items.topics[key]['inquiry_number']=(items.topics[key].fields.find(item=>item.title=="شماره استعلام")?.value || "");
            items.topics[key]['count']=(items.topics[key].fields.find(item=>item.title=="تعداد اقلام")?.value || "")+" "+(options[(items.topics[key].fields.find(item=>item.title=="واحد کالا")?.value || "")] || "");
            items.topics[key]['deadline']=(items.topics[key].fields.find(item=>item.title=="آخرین مهلت شرکت در استعلام")?.value || "");
            items.topics[key]['expert']=(items.topics[key].fields.find(item=>item.title=="کارشناس مربوطه")?.value || "");
            items.topics[key]['unit_price']=(items.topics[key].fields.find(item=>item.title=="واحد کالا")?.value || "");
        }
        console.log(items,"items")
        state.inquiry = items;
    },
    [SET_INQUIRY_PRICE](state,resource){
        state.supplierPrices = resource.data;
    },

    [SET_ERROR](state, error) {
        state.error = error;
    },

    [SET_LOADING](state, loading) {
        state.loading = loading;
    },
}